import { useMemo } from "react";
import { useIntl } from "react-intl";
import CustomSelect from "../CustomSelect";
import countryCodes from "~config/countryCodes";

type Props = {
  className?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  value?: string;
};

const SelectNationality = ({ className, disabled, onChange, value }: Props) => {
  const { formatMessage } = useIntl();

  const options = useMemo(
    () => countryCodes.filter((code) => code[0]).map((code) => ({ label: code[0], value: code[0] })),
    [],
  );

  return (
    <CustomSelect
      value={value}
      onChange={(value) => onChange?.(value as string)}
      options={options}
      placeholder={formatMessage({id: "nationality"})}
      showSearch
      allowClear
      className={className}
      disabled={disabled}
    />
  );
}

export default SelectNationality;
